export const SECTIONS = {
  FILES: 'Separate files',
  ARCHIVE: 'Files in archive',
};